<div class="main-section">
  <section *ngIf="this.gameConfig.sliderName === 'slider'">
    <div id="carouselExampleIndicators" class="carousel slide  hero-banner" data-bs-ride="carousel">
      <div class="carousel-indicators">
        <button type="button" *ngFor="let item of gameConfig.imageList; let i = index;" data-bs-target="#carouselExampleIndicators" attr.data-bs-slide-to="{{i}}" class="{{ (i == 0) ? 'active' : '' }}"
          attr.aria-label="Slide {{i}}"></button>

      </div>
      <div class="carousel-inner container">
        <ng-container *ngFor="let item of gameConfig.imageList; let i = index;">
        <div class="carousel-item" [ngClass]="{'active': i == 0}">
          <div class="row">
            <div class="col-lg-6  ps-lg-5 ps-0 order-1 order-lg-0">
              <div class="carousel-text">
                <h1 class="text-theme-green hero-heading">{{this.gameConfig.header1}}</h1>
                <h2 class="text-theme-green hero-sub-heading">{{this.gameConfig.header2}}</h2>
                <p>{{this.gameConfig.description}}</p>
              </div>
            </div>
            <div class="col-lg-6 text-center order-0 order-lg-1 mt-3 carousel-img">
              <img [src]="item" alt="carousel-1" class=" game-carousel" />
            </div>
          </div>
        </div>
      </ng-container>
      </div>
      <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators"
        data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators"
        data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>
  </section>

  <section *ngIf="this.gameConfig.sliderName === 'noslider'">
    <div class="">
        <div class="container ">
            <div class="px-60">
                <div class="row">
                    <div class="col-md-6  ps-lg-5 ps-0 order-1 order-md-0">
                        <div class="carousel-text video-text">
                            <!-- <h4>{{portalName}}</h4> -->
                            <h1 class="text-theme-green hero-heading">{{this.gameConfig.header1}}</h1>
                <h2 class="text-theme-green hero-sub-heading">{{this.gameConfig.header2}}</h2>
                            <p>{{this.gameConfig.description}}</p>
                        </div>
                    </div>
                    <div class="col-md-6 text-center order-0 order-md-1 mt-3 carousel-img">
                        <div class="image-warp d-flex" *ngFor="let item of gameConfig.imageList; let i = index;">
                            <img [src]="item" class="img-fluid" alt="image" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </section>


  <section class="design-responsive-1" *ngIf="this.gameConfig.sliderName === 'videoSlider'">
    <div class=" hero-banner">
        <div class="container ">
            <div class="px-60">
                <div class="row">
                    <div class="col-md-6  ps-lg-5 ps-0 order-1 order-md-0">
                        <div class="carousel-text video-text">
                          <h1 class="text-theme-green hero-heading">{{this.gameConfig.header1}}</h1>
                          <h2 class="text-theme-green hero-sub-heading">{{this.gameConfig.header2}}</h2>
                          <p>{{this.gameConfig.description}}</p>                          <a href="#" class="btn btn-ghost btn-post mt-0">View</a>
                        </div>
                    </div>
                    <div class="col-md-6 text-center order-0 order-md-1 mt-3 carousel-img">
                        <div class="image-warp d-flex">
                            <div class="swiper mySwiper">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide" *ngFor="let item of gameConfig.imageList; let i = index;" >
                                        <div class="image-slider img-1">
                                            <img [src]="item" alt="" class="img-fluid">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </section>


  <section class="mt-64 design-responsive">
      <div class="design-8">
          <img src="./../../assets/images/2.png" alt="">
      </div>
      <div class="container">
          <div class="row">
              <div class="col-lg-12">
                  <div class="section-title text-center">
                      <h2>{{this.gameConfig.tc}}</h2>
                      

              </div>
              
              <div class="col-lg-6 mx-auto">

                  <!-- <div class="container">
                      <ul class="conditions">
                        <li>After the unsubscription of the Daily package, the portal content can be accessed even after 24 hours.</li>
                        <li>Data charges would apply for browsing & downloading contents on this portal.</li>

                      </ul>

                      <ul class="conditions mt-1">
                          <li>Contents are compatible with all handsets.</li>
                          <li>To make use of this service, one must be more than 18 years old or have received permission from your parents or person who is authorized to pay your mobile bill.</li>
                      </ul>

                      <ul class="conditions mt-1">
                          <li>To unsubscribe the Service log into my account and click on unsubscribe.</li>

                      </ul>

                  </div> -->

                 
                  <p style="color: wheat;">{{tc.description}}</p>
                  <div style="color: wheat;">
                  <div *ngIf="this.queryParam.serviceId == '1345'">
                    To unsubscribe from Selective Games send <br><B>UNSUB Q713</B> to <B>93052</B>
                  </div>
                  <div *ngIf="this.queryParam.serviceId == '1348'">
                    To unsubscribe from Selective Games send <br><B>UNSUB U713</B> to <B>93052</B>
                  </div>
                  <div *ngIf="this.queryParam.serviceId == '1349'">
                    To unsubscribe from Selective Games send <br> <B>UNSUB E713</B> to <B>93052</B>
                  </div>
                </div>
              </div>

          </div>
      </div>

      <div *ngIf="queryParam.id =='427' && queryParam.biller == 'MOBIXONE' && queryParam.operator == '2014'">
        <div class="container mt-3">
          <p>These General Terms and Conditions for Registration, Use of the EXTREME SPORTS Service managed by Globocom Infotech Pvt. Ltd and any person using the Service (here in after referred to as the USER) who uses the service on the website.</p>
          <p>EXTREME SPORTS is a weekly subscription service. You will be charged R39.99/week (network fees may apply), to your mobile phone bill and your subscription will be renewed automatically. You can unsubscribe from the service portal or by dialing *123# and following the prompts.</p>
          <p>You also confirm that you are 18 years or older and are the mobile account holder or you have consent from the mobile account holder. The service must only be used with the permission of a parent or guardian. This service has compatibility requirements with any handset. By using the Service, the User agrees to the General Terms of this service. This service must only use with the permission of the bill-payer (for paid services). Billing errors will be handled by Globocom Infotech Pvt. Ltd and operator.</p>
          <p>The service must not be used to:</p>
          <ol>
            <li>Intentionally engage in Illegal conduct.</li>
            <li>To knowingly create, store or disseminate any Illegal content.</li>
            <li>To knowingly Infringe copyright.</li>
            <li>To knowingly Infringe any intellectual property rights.</li>
            <li>To send spam or promote the sending of spam.</li>
          </ol>
          <p>Globocom Infotech Pvt. Ltd has the right to suspend or terminate the services of any customer who does not comply with these terms and conditions or any other related contractual obligations. Globocom Infotech Pvt. Ltd has the right to take down, any content (hosted as part of the service) that it considers illegal or for which it has received a take-down notice.</p>
          <p>Choose a subscription plan. The user selects a specific subscription plan for which he pays. In the case of any support required, you can email to support@globocom.info or contact +27 10 010 5274. Globocom Infotech Pvt. Ltd is a member of WASPA and is bound by the WASPA Code of Conduct. Customers have the right to approach WASPA to lodge a complaint in accordance with the WASPA complaints procedure. Globocom Infotech Pvt. Ltd may be required to share information relating to a service or a customer with WASPA for the purpose of resolving a complaint. WASPA web site www.waspa.org .</p>
        </div>
      </div>



</div>
